// utils/chatUtils.ts
export const useChatModal = () => {
  const handleHeadingClick = (text: string) => {
    if ((window as any).openChatModal) {
      (window as any).openChatModal(text);
    }
  };

  return { handleHeadingClick };
};
